import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const AlertContent = styled.div`
  flex: 1 1 auto;
`;

export const IconContainer = styled.div`
  flex: 0 0 auto;
  margin-right: 10px;

  svg {
    font-size: 25px;
    stroke: #000000;
    stroke-width: 0.2px;
  }
`;

export const Alert = styled.div`
  border: 1px solid ${theme.colors.border.main};
  background-color: ${theme.colors.bg.accent};
  border-radius: 2px;
  padding: ${size(3)};
  font-weight: ${theme.font.weight.medium};
  font-size: 16px;
  font-weight: 600;
  display: flex;
  ${theme.screens.LtMd} {
    padding: ${size(2)};
    font-size: ${size(1.9)};
  }

  &.tone-inactive {
    border-color: ${theme.colors.ui.neutral};
    background-color: ${theme.colors.ui.neutral};

    ${IconContainer} {
      color: ${theme.colors.bg.alt};
    }
  }

  &.container-size {
    max-width: ${theme.distances.contentMaxWidth};
  }
`;
